import {ps_order_detail_update} from "../../api/order_detail.api"


const getDefaultState = () => {
    return {
        order_details: []
    }
}

// initial state
const state = getDefaultState()


const mutations = {
    set_ps_order_details(state, order_details) {
        state.order_details = order_details
    },

    add_ps_order_detail(state, ps_order_detail) {
        state.order_details = [...state.order_details,ps_order_detail]
    },

    update_order_detail(state,od){

        state.order_details = [
            ...state.order_details.filter(element => element.id_order_detail !== od.id_order_detail),
            od
        ]

    },
    resetState (state) {
        Object.assign(state, getDefaultState())
    }
}

const actions = {

    update_order_detail({state, commit}, order_detail)
    {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            ps_order_detail_update(order_detail)
                .then((response) => {
                    if (response.status == '200') {
                        // Si OK on commit le state
                       // commit('update_order_detail',order_detail);
                        this._vm.$message({
                            message: 'Mise à jour détail OK',
                            type: 'success',center: true
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        )
    }
}

const getters = {
    orderDetails: ((state, getters, rootState, rootGetters) => (id_order, id_user = null) =>
        {
            if(id_user !== null)
            {
                let odids = []
                let td = rootGetters['td_todo/user_td_todos'](id_user)

                td.forEach(item => {
                    if (item.active)
                        odids.push(item.id_order_detail)
                })

                return state.order_details.filter(d => d.id_order == id_order && odids.includes(d.id_order_detail)).sort(function(a, b) {
                    return a.id_order_detail - b.id_order_detail;
                });

            }else{
                return state.order_details.filter(d => d.id_order === id_order).sort(function(a, b) {
                    return a.id_order_detail - b.id_order_detail;
                });

            }
        }
    ),

    orderDetail: (state => (id_order_detail) => (
        state.order_details.filter(d => d.id_order_detail === id_order_detail)
    ))
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
